import { Instance } from 'mobx-state-tree';
import { RouteStopUnschedulingDtoModelBase } from './RouteStopUnschedulingDtoModel.base';

/* The TypeScript type of an instance of RouteStopUnschedulingDtoModel */
export interface RouteStopUnschedulingDtoModelType extends Instance<typeof RouteStopUnschedulingDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopUnschedulingDtoModel */
export { selectFromRouteStopUnschedulingDto, routeStopUnschedulingDtoModelPrimitives, RouteStopUnschedulingDtoModelSelector } from './RouteStopUnschedulingDtoModel.base';

/**
 * RouteStopUnschedulingDtoModel
 *
 * Route unscheduling event
 */
export const RouteStopUnschedulingDtoModel = RouteStopUnschedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
